import { gql } from "@apollo/client";
import { messageHeaders } from "features/common/fragments";

export const DOCUMENT_STATE_UPDATED = gql`
  subscription documentStateUpdated($documentId: Int!) {
    documentStateUpdated(documentId: $documentId) {
      documentId
      documentStateId
      documentStateCode
      documentStateName
      silentMode
      messageCode
      documentAllowedTransitions {
        id
        code
        name
        documentTypeId
        requestComment
        commentIsMandatory
        requestReason
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const CHANGE_DOCUMENT_STATE_FAILED = gql`
  subscription changeDocumentStateFailed($documentId: Int!) {
    changeDocumentStateFailed(documentId: $documentId) {
      message
      oldStateId
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;
